import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DemandReductionDataService } from './demand-reduction-data.service';

@Injectable({
  providedIn: 'root'
})
export class DemandOverrideService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private demandReduction: DemandReductionDataService) {}

  postDemandOverride(demandOverrideData){
    this.http.post(`${this.baseUrl}api/DemandOverride/Post`, demandOverrideData, {observe: 'response'}).subscribe(response => {
      if(response.status === 200) {
        this.demandReduction.getDemandReduction();
      }
    });
  }
}

export interface DemandReductionAdjustment {
  DemandEntityId: number;
  DemandValue: number;
  DemandDate: string;
  Notes: string;
}